/* =============================================================================
 * M.M.LaFleur — header float state across soft navigation.
 *
 * mm_header.liquid decides two things server-side, once, from the template
 * being rendered:
 *
 *   data-floating       whether the header sits transparent over a hero
 *   .mm-header-spacer   rendered only when it does NOT, to reserve its height
 *
 * The header lives outside Barba's swap container, so neither is recalculated
 * on a soft navigation. Go homepage -> PDP and the header keeps `floating`
 * from the homepage: transparent nav over a white product page, an inverted
 * wordmark that all but disappears, and no spacer, so the breadcrumb slides
 * underneath the fixed header. Hard-refresh the same PDP and it is fine, which
 * is why it looked intermittent.
 *
 * Rather than duplicate the float_mode setting in JS, this keys off what
 * actually justifies floating: a full-bleed hero directly under the header.
 * .mm-hero on the homepage, .mm-plp-hero on collections — exactly the
 * templates float_mode allows.
 *
 * The spacer is created and toggled here too, since the server only ever
 * rendered it for the first page of the session.
 * ========================================================================== */

(function () {
  "use strict";

  var HERO = ".mm-hero, .mm-plp-hero";
  var seenFirst = false;
  var floatDisabled = false;
  var pending = null;

  function spacerFor(root) {
    var spacer = document.querySelector(".mm-header-spacer");
    if (!spacer) {
      spacer = document.createElement("div");
      spacer.className = "mm-header-spacer";
      if (root.parentNode) root.parentNode.insertBefore(spacer, root.nextSibling);
    }
    return spacer;
  }

  function sync() {
    var root = document.querySelector(".mm-header-root");
    if (!root) return;

    /* mm-search.js parks the header in its solid state while the panel is
       open and restores the previous value on close. Leave it alone. */
    var search = document.querySelector("[data-mm-search]");
    if (search && search.getAttribute("data-open") === "true") return;

    var hasHero = !!document.querySelector(HERO);

    /* If the very first page had a hero and the server still said not to
       float, the theme setting forbids it — never turn it on later. */
    if (!seenFirst) {
      seenFirst = true;
      if (hasHero && root.getAttribute("data-floating") !== "true") floatDisabled = true;
    }

    var shouldFloat = hasHero && !floatDisabled;
    root.setAttribute("data-floating", shouldFloat ? "true" : "false");

    var spacer = spacerFor(root);
    spacer.style.display = shouldFloat ? "none" : "";
  }

  function schedule() {
    if (pending) window.cancelAnimationFrame(pending);
    pending = window.requestAnimationFrame(function () {
      pending = null;
      sync();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }

  /* Barba replaces the main container rather than firing a navigation event
     this script can see, so watch the DOM and re-check when it changes. */
  var observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("popstate", schedule);
  document.addEventListener("shopify:section:load", schedule);
}());
